import { useContext } from 'react';

import { SubscriptionActionsContext } from './SubscriptionActionsContext';

export const useSubscriptionActionsContext = () => {
  const context = useContext(SubscriptionActionsContext);
  if (!context) {
    throw new Error('useSubscriptionActionsContext must be used within a SubscriptionActionsProvider');
  }
  return context;
};
